import { useEffect, useState } from 'react';
import { useLocation, useLoaderData, Navigate, useNavigation, useOutlet, useRouteLoaderData, useMatches } from 'react-router-dom';
import { Loader } from '../Commons';
import { AlertProvider, Alert } from './Alert';
import { Sidebar } from './Menu';

const PageWrap = ({ requireAuth, children }) => {
  // wrap any route that requires authentication.
  // if user is not logged in, redirect to login page.

  const location = useLocation();
  const data = useLoaderData();
  const [isLogin, setIsLogin] = useState(true);
  const nav = useNavigation();
  const outlet = useOutlet();

  // get child data for auth verification
  const matches = useMatches();
  const routeId = (matches && matches.length > 0) ? matches[matches.length-1].id : 'dummy-null-route';
  const childrenData = useRouteLoaderData(routeId) // get data for children routes

  useEffect(() => {
    if(!requireAuth)
      return;

    const token = sessionStorage.getItem('accessToken');
    if(!token) {
      setIsLogin(false);
      return;
    }

    if(data && data.errorCode && data.errorCode >= 100 && data.errorCode <= 110) {
        setIsLogin(false);
        return;
    }
    
    if(childrenData && childrenData.errorCode && childrenData.errorCode >= 100 && childrenData.errorCode <= 110)
        setIsLogin(false);
  }, [data, childrenData, requireAuth]);

  if(!isLogin && requireAuth)
      return <Navigate to='/user/login' state={{ from: location }} replace />

  return (
    <AlertProvider>
      <div className='hidden 2xl:w-1/6 lg:w-1/4 lg:block h-screen sticky top-0'> {/* temporary hide menu until fully responsive */}
        <Sidebar />
      </div>
      <div className='p-2 lg:p-4 flex flex-col gap-6 w-full'>
        { nav.state === 'loading' ? <Loader /> : outlet || children }
        <Alert />
      </div>
    </AlertProvider>
  );
}

export default PageWrap;